(() => {
  if (window.__HF_TYPEWRITER_INIT__) return;
  window.__HF_TYPEWRITER_INIT__ = 1;

  function initInstance(root) {
    if (root.dataset.hfTypewriterInit === '1') return;
    root.dataset.hfTypewriterInit = '1';

    const dynamicEl = root.querySelector('.hf-typewriter__dynamic');
    const wordsContainer = root.querySelector('.hf-typewriter__words');
    if (!dynamicEl || !wordsContainer) return;

    const spans = wordsContainer.querySelectorAll('.hf-typewriter-word');
    const words = Array.from(spans)
      .map((span) => ({
        text: (span.dataset.word || span.textContent || '').trim(),
        color: span.dataset.color || '',
        italic: span.dataset.italic === 'true',
        bold: span.dataset.bold === 'true',
        blockId: span.dataset.blockId,
      }))
      .filter((w) => w.text);

    if (!words.length) return;

    const typingSpeed = parseInt(root.dataset.typingSpeed, 10) || 100;
    const displayTime = parseInt(root.dataset.wordDisplayTime, 10) || 2000;

    let wi = 0;
    let ci = 0;
    let deleting = false;

    const step = () => {
      const w = words[wi];
      if (deleting) {
        dynamicEl.textContent = w.text.substring(0, ci - 1);
        ci--;
      } else {
        dynamicEl.textContent = w.text.substring(0, ci + 1);
        ci++;
      }
      dynamicEl.style.color = w.color || '';
      dynamicEl.style.fontStyle = w.italic ? 'italic' : '';
      dynamicEl.style.fontWeight = w.bold ? '700' : '';
      dynamicEl.className = `hf-typewriter__dynamic hf-typewriter-word--${w.blockId}`;

      if (ci === 0 && deleting) {
        dynamicEl.textContent = '\u00A0';
      }

      if (!deleting && ci === w.text.length) {
        deleting = true;
        setTimeout(step, displayTime);
      } else if (deleting && ci === 0) {
        deleting = false;
        wi = (wi + 1) % words.length;
        setTimeout(step, typingSpeed);
      } else {
        setTimeout(step, typingSpeed);
      }
    };

    dynamicEl.textContent = '';
    step();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.hf-typewriter').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:load', (e) => initAll(e.target));
})();
